<template>
  <!-- 分页卡片展示列表 -->
  <div class="cardMain">
    <div class="cardTop" style="width:100%;">
      <div>
        <div style="display:flex;flex-flow:row wrap;" class="showCard">
          <div v-for="item in dataList" :key="item.id">
            <div class="cardBody" @click="seeInfo(item)">
              <img :src="item.icon" class="cardPicture" v-if="item.icon != null" />
              <img :class="[chooseValue != item.id ? 'cardPicture' : 'cardPictureHover']" src="@/assets/image/wys.png" class="cardPicture" v-else />
              <div class="cardTitle">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cardListFooter">
      <NewPagunation :total="total" :pageSize="pageSize" @getPage="getPage"></NewPagunation>
    </div>
  </div>
</template>
<script>
import { getOpenMenu } from "@/api/common";
import TopButtom from "@/components/common/TopButtom.vue";
import NewPagunation from "@/components/common/NewPagunation.vue";
import pageFen from "@/components/common/pageFen.vue";
import { getMenuOpenList } from "@/api/publicApi";
export default {
  name: "CardList",
  components: { NewPagunation, TopButtom, pageFen },
  props: ["type"],
  data() {
    return {
      chooseValue: -1,
      dataList: [],
      current: 1,
      pageSize: 6,
      total: 0,
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.current = 1;
        if (deviceId == 1) {
          this.getFoodRecommendFunction();
        } else if (deviceId == 2) {
          this.getFoodCharacteristicFunction();
        } else if (deviceId == 3) {
          this.getFoodLocalFunction();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() { },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    handleRefresh() {
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getFoodRecommendFunction();
      } else if (deviceId == 2) {
        this.getFoodCharacteristicFunction();
      } else if (deviceId == 3) {
        this.getFoodLocalFunction();
      }
    },
    //分页
    getPage(current) {
      this.current = current;
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getFoodRecommendFunction();
      } else if (deviceId == 2) {
        this.getFoodCharacteristicFunction();
      } else if (deviceId == 3) {
        this.getFoodLocalFunction();
      }
    },
    //美食推荐
    async getFoodRecommendFunction() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'food_recommend');
      if (code == 200) {
        this.dataList = data.records;
        let BASE_URL = this.Global;
        this.dataList.forEach(function (element) {
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },
    //美食当地
    async getFoodLocalFunction() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'food_local');
      if (code == 200) {
        this.dataList = data.records;
        let BASE_URL = this.Global;
        this.dataList.forEach(function (element) {
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },
    //美食特色
    async getFoodCharacteristicFunction() {
      const { code, data } = await getOpenMenu(this.current, this.pageSize, 'food_characteristic');
      if (code == 200) {
        this.dataList = data.records;
        let BASE_URL = this.Global;
        this.dataList.forEach(function (element) {
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.url != null ? (element.url = `${BASE_URL}${element.url}`) : "";
        });
        this.total = data.total;
      }
    },
    //详情
    seeInfo(info) {
      this.$emit("seeInfo", info);
    }
  }
};
</script>
<style scoped>
.cardListFooter {
  width: 100%;
  text-align: center;
  height: 5.55vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.22vh;
}
.cardTop {
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* margin: 136px 6% 20px 5%; */
}
.cardTitle {
  text-align: center;
  width: 21.927vw;
  height: 4.537vh;
  line-height: 4.537vh;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 2;
  /* left: 10px; */
  color: #ffffff;
  bottom: 0px;
}
.cardTitle:hover {
  text-align: center;
  width: 21.927vw;
  height: 4.537vh;
  line-height: 4.537vh;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 2;
  /* left: 10px; */
  color: #ffffff;
  bottom: 0px;
  font-weight: bold;
}
.cardPicture {
  width: 100%;
  height: 100%;
  position: relative;
}
.cardPictureHover {
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 0.6;
}
.cardBody {
  position: relative;
  margin-left: 0.3645vw;
  width: 21.927vw;
  height: 29.074vh;
  margin-top: 0.5208vh;
  cursor: pointer;
}

.cardMain::-webkit-scrollbar {
  width: 8px;
}
/* 滑块 */
.cardMain::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #ababab;
}
/* 滑槽 */
.cardMain::-webkit-scrollbar-track {
  border-radius: 4px;
}
.cardMain {
  height: 69.259vh;
  /* height: 85.555vh; */
  overflow-y: scroll;
}
.showCard {
  margin-left: 2.5%;
  position: relative;
}
.mask {
  position: absolute;
  background: rgba(101, 101, 101, 0.6);
  color: red;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 222;
}
</style>



// WEBPACK FOOTER //
// src/views/food/cardShowList.vue